module.exports = __webpack_public_path__ + "static/media/itakeoff.036ddfe8.svg";